export class GetDataCatalogDatasetResponse {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "dataset",
            "baseName": "dataset",
            "type": "DataCatalogDataset",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return GetDataCatalogDatasetResponse.attributeTypeMap;
    }
    constructor() {
    }
}
